import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  TextField,
  Button,
  IconButton,
  InputAdornment,
  Typography,
  Box,
  Avatar,
  Slide,
  makeStyles,
  AppBar,
  Toolbar,
  Container,
  Badge,
} from "@material-ui/core";
import {
  Visibility,
  VisibilityOff,
  Lock,
  Close,
  CheckCircle,
  Person,
  Notifications,
  Settings,
  Menu as MenuIcon,
} from "@material-ui/icons";
import CommonDialog from "../CommonComponents/CommonDialog";
import CommanModal from "../CommonComponents/CommanModal/CommanModal";
import { updatePassword } from "../../actions/changepasswordAction";
import { useSnackbar } from "../CommonComponents/SnackbarProvider";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
  appBar: {
    // background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    // boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
    padding: "8px 0",
  },
  logo: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    cursor: "pointer",
  },
  logoIcon: {
    // background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
    // width: 40,
    // height: 40,
  },
  logoText: {
    fontWeight: 700,
    fontSize: "1.5rem",
    color: "white",
    letterSpacing: "0.5px",
  },
  headerActions: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
  },
  iconButton: {
    color: "white",
    "&:hover": {
      background: "rgba(255,255,255,0.1)",
    },
  },
  changePasswordBtn: {
    background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
    color: "white",
    padding: "10px 24px",
    borderRadius: "25px",
    fontWeight: 600,
    textTransform: "none",
    boxShadow: "0 4px 15px rgba(245,87,108,0.4)",
    "&:hover": {
      background: "linear-gradient(135deg, #f5576c 0%, #f093fb 100%)",
      transform: "translateY(-2px)",
      boxShadow: "0 6px 20px rgba(245,87,108,0.6)",
    },
    transition: "all 0.3s ease",
  },
  dialog: {
    "& .MuiDialog-paper": {
      borderRadius: "20px",
      overflow: "visible",
    },
  },
  dialogContent: {
    padding: 0,
    overflow: "visible",
  },
  modalHeader: {
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    padding: theme.spacing(4),
    position: "relative",
    borderRadius: "20px 20px 0 0",
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(2),
    top: theme.spacing(2),
    color: "white",
    background: "rgba(255,255,255,0.2)",
    "&:hover": {
      background: "rgba(255,255,255,0.3)",
    },
  },
  label: {
    color: "#475569",
    fontWeight: 600,
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(1),
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  lockAvatar: {
    width: 80,
    height: 80,
    margin: "0 auto 16px",
    background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
    boxShadow: "0 8px 32px rgba(245,87,108,0.4)",
  },
  lockIcon: {
    fontSize: 40,
  },
  modalTitle: {
    color: "white",
    fontWeight: 700,
    fontSize: "1.75rem",
    textAlign: "center",
    marginBottom: theme.spacing(1),
  },
  modalSubtitle: {
    color: "rgba(255,255,255,0.9)",
    textAlign: "center",
    fontSize: "0.95rem",
  },
  formContainer: {
    padding: theme.spacing(4),
  },
  textField: {
    marginBottom: theme.spacing(3),
    "& .MuiOutlinedInput-root": {
      borderRadius: "12px",
      "&:hover fieldset": {
        borderColor: "#667eea",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#667eea",
        borderWidth: "2px",
      },
    },
    "& .MuiInputLabel-outlined.Mui-focused": {
      color: "#667eea",
    },
  },
  submitButton: {
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    color: "white",
    padding: "14px",
    borderRadius: "12px",
    fontWeight: 600,
    fontSize: "1rem",
    textTransform: "none",
    marginTop: theme.spacing(2),
    boxShadow: "0 4px 20px rgba(102,126,234,0.4)",
    "&:hover": {
      background: "linear-gradient(135deg, #764ba2 0%, #667eea 100%)",
      boxShadow: "0 6px 25px rgba(102,126,234,0.6)",
    },
    transition: "all 0.3s ease",
  },
  cancelButton: {
    padding: "14px",
    borderRadius: "12px",
    fontWeight: 600,
    fontSize: "1rem",
    textTransform: "none",
    marginTop: theme.spacing(2),
    color: "#667eea",
    border: "2px solid #667eea",
    "&:hover": {
      background: "rgba(102,126,234,0.05)",
      border: "2px solid #667eea",
    },
  },
  errorBox: {
    background: "linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%)",
    color: "white",
    padding: theme.spacing(2),
    borderRadius: "12px",
    marginTop: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    boxShadow: "0 4px 15px rgba(255,107,107,0.3)",
  },
  successBox: {
    background: "linear-gradient(135deg, #56ab2f 0%, #a8e063 100%)",
    color: "white",
    padding: theme.spacing(2),
    borderRadius: "12px",
    marginTop: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    boxShadow: "0 4px 15px rgba(86,171,47,0.3)",
  },
  helperText: {
    marginTop: theme.spacing(0.5),
    fontSize: "0.75rem",
    color: "#666",
  },
  buttonGroup: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: theme.spacing(2),
  },
}));

export default function BeautifulChangePassword({ open, setOpen }) {
  const classes = useStyles();
  const { showSnackbar } = useSnackbar();
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  //   const handleOpen = () => {
  //     setOpen(true);
  //     setError("");
  //     setSuccess("");
  //   };

  //   const handleClose = () => {
  //     setOpen(false);
  //     setOldPassword("");
  //     setNewPassword("");
  //     setConfirmPassword("");
  //     setError("");
  //     setSuccess("");
  //   };
  const clearFeild = () => {
    setOldPassword("");
    setNewPassword("");
    setConfirmPassword("");
    setError("");
    setSuccess("");
  };

  const handleSubmit = async () => {
    setError("");
    setSuccess("");

    if (!oldPassword || !newPassword || !confirmPassword) {
      setError("All fields are required");
      return;
    }
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    if (!passwordRegex.test(newPassword)) {
      setError(
        "New password must contain at least 8 characters, one uppercase, one lowercase, one number and one special character"
      );
      return;
    }
    if (newPassword !== confirmPassword) {
      setError("New password and confirm password do not match");
      return;
    }
    if (oldPassword === newPassword) {
      setError("New password must be different from old password");
      return;
    }
    const data = {
      email: JSON.parse(sessionStorage.getItem("data"))?.email,
      oldPassword: oldPassword,
      password: confirmPassword,
    };

    await updatePassword.changePassword(data).then((response) => {
      console.log(response, "responseffff");
      if (response.data != null && response?.responseCode == 200) {
        showSnackbar(response?.responseDescription, "success");
        window.open("/", "_self");
        clearFeild();
      } else if (response?.responseCode == 403) {
        showSnackbar(response?.responseDescription, "error");
      } else {
        clearFeild();
        console.log("error");
      }
    });
  };

  return (
    <div>
      {/* Beautiful Header */}
      {/* <Button
        className={classes.changePasswordBtn}
        startIcon={<Lock />}
        onClick={handleOpen}
      >
        Change Password
      </Button> */}
      <CommanModal
        title={"Change Your Password"}
        open={open}
        setOpen={setOpen}
        handleSubmit={handleSubmit}
        clearFeild={clearFeild}
      >
        <Box className={classes.formContainer}>
          <Typography className={classes.label}>Current Password</Typography>
          <TextField
            fullWidth
            // label="Current Password"
            type={showOldPassword ? "text" : "password"}
            variant="outlined"
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
            className={classes.textField}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowOldPassword(!showOldPassword)}
                    edge="end"
                  >
                    {showOldPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <Typography className={classes.label}>New Password</Typography>
          <TextField
            fullWidth
            // label="New Password"
            type={showNewPassword ? "text" : "password"}
            variant="outlined"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            className={classes.textField}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowNewPassword(!showNewPassword)}
                    edge="end"
                  >
                    {showNewPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <Typography className={classes.label}>Confirm Password</Typography>
          <TextField
            fullWidth
            // label="Confirm New Password"
            type={showConfirmPassword ? "text" : "password"}
            variant="outlined"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            className={classes.textField}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    edge="end"
                  >
                    {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          {error && (
            <Box className={classes.errorBox}>
              <Close />
              <Typography>{error}</Typography>
            </Box>
          )}

          {success && (
            <Box className={classes.successBox}>
              <CheckCircle />
              <Typography>{success}</Typography>
            </Box>
          )}

          {/* <Box className={classes.buttonGroup}>
            <Button
              onClick={handleClose}
              className={classes.cancelButton}
              variant="outlined"
              fullWidth
            >
              Cancel
            </Button>
            <Button
              onClick={handleSubmit}
              className={classes.submitButton}
              variant="contained"
              fullWidth
            >
              Update Password
            </Button>
          </Box> */}
        </Box>
      </CommanModal>
    </div>
  );
}
